/* eslint-disable no-shadow */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-form';

import Img from '../../components/Img';
import EventSport from '../../components/Events/EventEditWizard/Fields/EventSport';
import { isActive as isClubActive, canRunEvents as clubCanRunEvents, currentMemberIsAdmin, getNewClubPath } from '../../utils/clubs';
import { useStatsig } from '../../components/hooks/useStatsig';
import StatsigLink from '../../components/Links/StatsigLink';
import StatsigRedirect from '../../components/redirect/StatsigRedirect';
import { showSplash } from '../../actions/splash-actions';
import config from '../../../config';

import styles from './eventCreate.scss';

const EventCreateChooseSport = (props) => {
    const club = useSelector(({ club }) => club);
    const dispatch = useDispatch();
    const { checkGate, featureGates } = useStatsig();
    const isClubRedirectEnabled = checkGate(featureGates.CLUB_LINKS_REDIRECT);
    const { clubDetails, clubId } = club;

    const closeCreatePage = () => {
        if (clubId) {
            if (isClubRedirectEnabled) {
                const clubTierTypeId = clubDetails.tierTypeId || clubDetails.tierType?.id;
                const newClubPath = getNewClubPath(clubTierTypeId);
                dispatch(showSplash());
                window.location.href = `${config.nextAppHost}/${newClubPath}/${clubId}`;
                return;
            }
            props.history.push(`/clubs/${clubId}`);
        } else {
            props.history.push(`/home`);
        }
    };

    const onSubmit = (values) => {
        const params = new URLSearchParams(props.location.search);
        params.delete('sportTypeId');
        params.append('sportTypeId', values.sportTypeId);
        props.history.push({ search: params.toString() });
    };

    return (
        <div>
            <div className="navbar navbar-expand-md navbar-light mt0 sticky-top">
                <div className="container" style={{ position: 'relative' }}>
                    <div className="row w-100">
                        <div className="col d-flex aic">
                            <div className="close-area" onClick={closeCreatePage}>
                                <Img className="close-icon" src="/img/icons/close-icon-lg.svg" />
                            </div>
                            <div className="d-inline d-md-none title-span text-medium text-uppercase text-dark text-center">
                                Create Event
                            </div>
                        </div>
                        <div className="col d-none d-md-flex aic jcc">
                            <div className="title-span text-medium text-uppercase text-dark text-center">
                                Create Event
                            </div>
                        </div>
                        <div className="col d-flex aic jce" />
                    </div>
                </div>
            </div>
            <div className={styles.page}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-6 offset-md-3">
                            <div className={`${styles.section}`}>
                                {(clubDetails && (!isClubActive(clubDetails) || !clubDetails || !clubCanRunEvents(clubDetails) || !currentMemberIsAdmin(clubDetails))) && (
                                    <StatsigRedirect
                                        gate={featureGates.CLUB_LINKS_REDIRECT}
                                        enabledTo={`${config.nextAppHost}/${getNewClubPath(clubDetails.tierTypeId || clubDetails.tierType?.id)}/${clubDetails?.id}`}
                                        disabledTo="/clubs"
                                    />
                                )}
                                <div className={`container bg-transparent pl0 pr0 pb8`}>
                                    {clubDetails && (
                                        <div className={`text-highlight2 text-teal`}>
                                            <StatsigLink
                                                gate={featureGates.CLUB_LINKS_REDIRECT}
                                                enabledTo={`${config.nextAppHost}/${getNewClubPath(clubDetails.tierTypeId || clubDetails.tierType?.id)}/${clubDetails?.id}`}
                                                disabledTo={`/clubs/${clubDetails.id}`}
                                            >
                                                {clubDetails.name}
                                            </StatsigLink>
                                        </div>
                                    )}
                                    <h2>
                                        Create an Event
                                    </h2>
                                    <div className="bb pb8">
                                        {clubDetails && !clubDetails.eventCount ? 'Let’s start creating your first event' : 'Let’s start creating your next event'}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 offset-md-3">
                            <Form
                                onSubmit={values => onSubmit({ ...values })}
                                onChange={formApi => onSubmit({ ...formApi.values })}
                                defaultValues={{}}
                            >
                                {(formApi) => {
                                    const { submitForm } = formApi;
                                    return (
                                        <form onSubmit={submitForm}>
                                            <div className={`form-group ${styles.radioGroup} row`}>
                                                <EventSport
                                                    field="sportTypeId"
                                                    className="col-12"
                                                />
                                            </div>
                                        </form>
                                    );
                                }}
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(EventCreateChooseSport);
